export const CUSTOMER_GRANT_RESOURCES = Object.freeze([
  { scope: 'CUSTOMER', label: '客户资料', description: '客户基础信息' },
  { scope: 'CUSTOMER_FOLLOW', label: '跟进记录', description: '客户跟进内容' },
  { scope: 'CUSTOMER_DOCUMENT', label: '客户资料文件', description: '资料表单与附件' },
  { scope: 'CUSTOMER_PLAN', label: '方案', description: '客户方案数据' },
  { scope: 'CUSTOMER_ORDER', label: '订单', description: '客户订单数据' },
  { scope: 'CUSTOMER_BILLING', label: '账单', description: '客户账单数据' }
])

const supportedScopes = new Set(CUSTOMER_GRANT_RESOURCES.map(resource => resource.scope))

export const normalizeCustomerGrantScopes = scopes => [
  ...new Set((Array.isArray(scopes) ? scopes : []).filter(scope => supportedScopes.has(scope)))
]

export const scopesFromCustomerGrants = grants => normalizeCustomerGrantScopes(
  (Array.isArray(grants) ? grants : []).map(grant => grant?.scope)
)
